<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.go(-1)" class="pull-right">Terug</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-alert variant="danger" :show="errors">
              Er ging iets mis...
              <ul class="mt-3">
                <li v-for="error in errors">{{error.toString()}}</li>
              </ul>
            </b-alert>
            <b-card>
              <template #header>
                Mededeling toevoegen
              </template>
              <b-form @submit.prevent="addItem">
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Titel">
                      <b-form-input type="text" required v-model="item.title"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="Actief">
                      <b-form-checkbox v-model="item.active"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="Vanaf">
                      <b-form-input type="date" required v-model="item.date_start"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="Tot">
                      <b-form-input type="date" v-model="item.date_end"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Inhoud">
                      <b-form-textarea type="text" required v-model="item.content"/>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="buttonDisabled">
                      Toevoegen
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
    import {addData} from '../../api';

    export default {
        name: 'announcement-create',
        data() {
            return {
                buttonDisabled: false,
                item: {
                    title: null,
                    active: true,
                    date_start: null,
                    date_end: null,
                    content: null,
                },
                errors: null,
            }
        },
        methods: {
            async addItem() {
                this.errors = null;
                this.buttonDisabled = true;
                const request = await addData('announcements', this.item);
                if (request.status === 200) {
                    this.$router.push({name: 'announcements.view', params: {id: request.data}});
                } else {
                    this.errors = request.data.errors;
                    this.buttonDisabled = false;
                }
            },
        }
    }
</script>
